/**
 * @generated SignedSource<<14d658db062bde2bfe8267586957de9d>>
 * @relayHash 2285bb60c1ae5119fa7ec8791454499a
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-nft/564.0.0-2026-06-16T17:18:39.177Z/NftPublicProfileReportModalMutation

import { ConcreteRequest } from 'relay-runtime';
export type PublicProfileReportInput = {
  additionalInfo?: string | null;
  clientMutationId?: string | null;
  username: string;
};
export type NftPublicProfileReportModalMutation$variables = {
  input: PublicProfileReportInput;
};
export type NftPublicProfileReportModalMutation$data = {
  readonly publicProfileReport: {
    readonly __typename: "PublicProfileReportPayload";
  } | null;
};
export type NftPublicProfileReportModalMutation = {
  response: NftPublicProfileReportModalMutation$data;
  variables: NftPublicProfileReportModalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PublicProfileReportPayload",
    "kind": "LinkedField",
    "name": "publicProfileReport",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NftPublicProfileReportModalMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NftPublicProfileReportModalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "app-buyer-nft/564.0.0-2026-06-16T17:18:39.177Z/NftPublicProfileReportModalMutation",
    "metadata": {},
    "name": "NftPublicProfileReportModalMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "cc8b7c8d41dd0e375a6241271a95ff9e";

export default node;
